<!--基础数据 超管帐号-->
<style lang="less" scoped>
    @import "~@/public/less/index.less";
    .zee-page{
        .head{
            margin: 0 20px 20px 20px; font-size: 1.1em; font-weight: bold;
        }
    }
</style>

<template>
    <div class="zee zee-page">
        <z-layout ref="zlayout"
                  v-if="superApi && superColumns"
                  :superPage="page"
                  :superApi="superApi"
                  @reloadData="reloadData">
            <!-- 面包屑 -->
            <template #breadcrumb><div></div></template>
            <!-- 头部 -->
            <template #head v-if="superTitle">
                <div class="head">{{superTitle}}</div>
            </template>
            <!-- 检索 -->
            <template #subHeadLeft>
                <z-search :superFilter="page.filter"
                          @change="bindSearchChange">
                </z-search>
            </template>
            <!-- 按钮组 -->
            <template #subHeadRight>
                <a-button-group>
                    <a-button type="primary" @click="$refs.zlayout.bindOpenCurd('新增')" ><template #icon><icon-plus /></template>新增</a-button>
                </a-button-group>
            </template>
            <!-- 子菜单 -->
            <template #menus v-if="menus">
                <a-menu mode="inline"
                        :style="{ height: '100%', borderRight: 0 }"
                        :defaultOpenKeys="[`/${router.info.path[0]}/${router.info.path[1]}`]"
                        :defaultSelectedKeys="[`${router.info.url}`]">
                    <template v-for="(item, index) in menus">
                        <a-sub-menu :key="index"
                                    v-if="item.info.show &&
                              item.info.type==='nav' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
                            <template v-for="(item2, index2) in menus">
                                <a-menu-item :key="index2"
                                             v-if="item2.info.type==='nav' &&
                                   item2.info.level===(router.navInfo.level+2)"
                                             @click="$fan.page.open(index2)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                                </a-menu-item>
                            </template>
                        </a-sub-menu>
                        <a-menu-item :key="'menu-' + index"
                                     v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                                     @click="$fan.page.open(index)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
                        </a-menu-item>
                    </template>
                </a-menu>
            </template>
            <!-- 列表 -->
            <template #body>
                <div class="body">
                    <z-table :superData="data"
                             :superColumns="superColumns"
                             :superFilter="page.filter"
                             @change="bindTableChange">
                        <template #actions="record">
                            <a-tooltip content="查看" position="bottom">
                                <a-button @click="$refs.zlayout.bindOpenCurd('详情', record)"><template #icon><icon-eye /></template></a-button>
                            </a-tooltip>
                            <a-tooltip content="编辑" position="bottom">
                                <a-button @click="$refs.zlayout.bindOpenCurd('编辑', record)"><template #icon><icon-edit /></template></a-button>
                            </a-tooltip>
                            <a-popconfirm content="删除不可恢复，是否继续？" position="br" @ok="bindDeleteRecord(record)">
                                <a-tooltip position="bottom" content="删除" >
                                    <a-button status="danger"><template #icon><icon-delete /></template></a-button>
                                </a-tooltip>
                            </a-popconfirm>
                        </template>
                    </z-table>
                </div>
            </template>
        </z-layout>
    </div>
</template>

<script>
    export default {
        name: 'ZPluginList',
        props: {
            superTitle: String,
            superApi: String,
            superColumns: Array
        },
        created() {
            this.page = this.$fan.utils.parse(this.def.page)
            this.data = this.$fan.utils.parse(this.def.data)
            console.log(this.menus)
        },
        mounted() {
            if (this.superApi && this.superColumns) {
                this.reloadData()
            }
        },
        computed: {
            routers() {
                return this.$store.state.routers || {}
            },
            router() {
                return this.routers[this.$route.path] || {}
            },
            menus() {
                let menus = {}
                if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
                    for (let k in this.routers) {
                        const router = this.routers[k]
                        let routerNavUrl = ""
                        for (let i =0; i < this.router.navInfo.level; i++) {
                            routerNavUrl = routerNavUrl+"/"+router.info.path[i]
                        }
                        if (router.info.type!=='nav' && routerNavUrl===this.router.navInfo.url) {
                            menus[router.info.url] = router
                        }
                    }
                }
                return Object.keys(menus).length>0 ? menus : false
            }
        },
        data() {
            return {
                data: {}, page: {},
                def: {
                    data: {},
                    page: {
                        initing: false,
                        loading: false,
                        filter: {
                            page: 1,
                            limit: 10
                        }
                    }
                }
            }
        },
        methods: {
            async loadData() {
                this.page.loading = true
                const {data} = await this.$fan.api.get(this.superApi, this.page.filter)
                this.data = data
                this.page.loading = false
            },
            async reloadData() {
                this.page.initing = true
                await this.loadData()
                await this.$fan.page.loadCallback(this.superColumns, this.data.data)
                this.page.initing = false
            },
            bindSearchChange(filters) {
                console.log('检索调试中：', filters)
            },
            bindTableChange(pagination, filters, sorter) {
                this.page.filter.page = pagination.current
                this.page.filter.limit = pagination.pageSize
                this.loadData()
            },
            async bindDeleteRecord({record}) {
                await this.$fan.api.delete(`${this.superApi}/${record.id}`)
                this.loadData()
            }
        }
    }
</script>
